import { Link } from "react-router-dom";

export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg
    viewBox="0 0 56 56"
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    {/* White bolt — the 'H' foundation */}
    <path
      d="M18 4 L30 4 L21 24 L31 24 L12 52 L19 30 L9 30 Z"
      fill="#FFFFFF"
    />
    {/* Lime upward arrow — launch */}
    <path
      d="M34 52 L34 22 L27 22 L40 4 L53 22 L46 22 L46 52 Z"
      fill="#C6FF00"
    />
  </svg>
);

export const Logo = ({ className = "", ...props }) => (
  <Link
    to="/"
    aria-label="HughLaunch — back to homepage"
    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
    className={`flex items-center gap-2.5 focus:outline-none ${className}`}
    data-testid="brand-logo"
    {...props}
  >
    <LogoMark className="h-8 w-8" />
    <span className="text-xl font-extrabold tracking-tight">
      <span className="text-white">Hugh</span>
      <span className="text-[#C6FF00]">Launch</span>
    </span>
  </Link>
);
